'use client'

import React from 'react'

import { Star } from '../../../icons'
import { Container } from './styles'

export type RateStar = 1 | 2 | 3 | 4 | 5

export interface RatingStarProps {
  /**
   * Number of the star
   */
  number: RateStar

  /**
   * Current value of the rating
   */
  value: number

  /**
   * Click handler
   */
  onClick?: (number: RateStar) => void

  /**
   * MouseEnter handler
   */
  onMouseEnter?: (number: RateStar) => void

  /**
   * MouseLeave handler
   */
  onMouseLeave?: (number: RateStar) => void

  /**
   * Whether the rating is editable
   */
  editable?: boolean

  /**
   * Whether the star is hovered on
   */
  hovering?: boolean
}

export const RatingStar = ({
  number,
  value,
  onClick,
  onMouseEnter,
  onMouseLeave,
  editable,
  hovering,
}: RatingStarProps) => {
  const handleClick = React.useCallback(() => {
    onClick?.(number)
  }, [onClick, number])

  const handleMouseEnter = React.useCallback(() => {
    onMouseEnter?.(number)
  }, [onMouseEnter, number])

  const handleMouseLeave = React.useCallback(() => {
    onMouseLeave?.(number)
  }, [onMouseLeave, number])

  return editable ? (
    <Container
      role="button"
      aria-label={`Rating star ${number}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Star
        type={number <= value ? number : 'empty'}
        outlined={!hovering && !(number <= value)}
      />
    </Container>
  ) : (
    <Star type={number <= value ? number : 'empty'} />
  )
}
